export const omitCustomProps = (...customProps) => ({
  shouldForwardProp: (prop) => !customProps.includes(prop),
});
